module.exports = __webpack_public_path__ + "img/b-yellow-s@3x.a90c1549.png";